import React, { FC } from 'react';
import ScrollToTop from '../../../components/layout/ScrollToTop';
import { Container, Stack, Typography } from '@mui/material';

const Kontakt: FC<{}> = () => {
	return (
		<>
			<ScrollToTop />
			<Container>
				<Stack spacing={4}>
					<Typography variant="h2">Kontakt</Typography>
					<Typography variant="h5"> Hier könnte ein Kontakt-Formular stehen</Typography>
				</Stack>
			</Container>
		</>
	);
};
export default Kontakt;
